import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectApps } from '../../selectors/applications';
import { selectAccess } from '../../selectors/auth';
import { installedAppCardSwitch } from './helpers';
import { APP_MANAGER } from './types';

function InstalledApps(props) {
  const { access, apps } = props;

  if (!apps) return <></>;

  const installedApps = apps.filter(
    ({ isSubscribed, isAvailable, type }) =>
      isSubscribed ||
      // epi portal manager should always be shown
      type === APP_MANAGER ||
      // so internal users don't need client membership
      (access.isInternal && isAvailable)
  );

  return <>{installedApps.map(installedAppCardSwitch)}</>;
}

InstalledApps.defaultProps = {
  access: {},
  apps: { apps: [] },
};

InstalledApps.propTypes = {
  access: PropTypes.shape({
    isAdmin: PropTypes.bool,
    isInternal: PropTypes.bool,
  }),
  apps: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        name: PropTypes.string,
        id: PropTypes.string,
        description: PropTypes.string,
        auth: PropTypes.shape({
          default: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string])),
        }),
        meta: PropTypes.shape({
          logo: PropTypes.string,
          link: PropTypes.string,
          slides: PropTypes.arrayOf(
            PropTypes.oneOfType([
              PropTypes.shape({
                title: PropTypes.string,
                copy: PropTypes.string,
                img: PropTypes.string,
              }),
            ])
          ),
        }),
      }),
    ])
  ),
};

const mapStateToProps = createStructuredSelector({
  apps: selectApps(),
  access: selectAccess(),
});

export function mapDispatchToProps() {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(InstalledApps);
